// Things the user did that a help tour (components/help) waits for, e.g.
// "the vacature was saved". Emitted from the API layer (api/api.ts) and a
// few components, so tours don't need to reach into component state.

export type TourEvent =
  | "vacature-created"
  | "vacature-updated"
  | "vacature-deleted"
  | "export"
  | "chat-sent"
  | "branch-requested"
  | "settings-saved";

const lastAt = new Map<TourEvent, number>();

export function emitTourEvent(event: TourEvent): void {
  lastAt.set(event, Date.now());
}

/** Whether `event` happened at or after `since` (a Date.now() timestamp). */
export function tourEventSince(event: TourEvent, since: number): boolean {
  return (lastAt.get(event) ?? 0) >= since;
}
